
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
    name: 'MxLoader',
})
export default class MxLoader extends Vue {}

